import script from "./BotaoSalvar.vue?vue&type=script&setup=true&lang=js"
export * from "./BotaoSalvar.vue?vue&type=script&setup=true&lang=js"

import "./BotaoSalvar.vue?vue&type=style&index=0&id=79c37208&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c37208"]])

export default __exports__